/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable max-len */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
// import React, { useState } from "react";
import PropTypes from "prop-types";
import React from "react";
import { getDistanceMax, getDistanceMinPositive } from "../../store/data/cartesianData";
import t from "../../../Common/utils/translation/translator";
import DeleteCross from "../../../Common/components/Icons/DeleteCross/DeleteCross";
import InputPlaceHolder from "../../../Common/components/Inputs/InputPlaceHolder/InputPlaceHolder";
import "./LoadsParametersRows.scss";

const PAYLOAD_LIMIT = 2000;
const DISTANCE_MAX = getDistanceMax();
const DISTANCE_MIN_POSITIVE = getDistanceMinPositive();
const DISTANCE_TOOLTIP = `The value should be between ${DISTANCE_MIN_POSITIVE} and ${DISTANCE_MAX}.`;
const PAYLOAD_TOOLTIP = `The value should be between 1 and ${PAYLOAD_LIMIT}`;

const LoadParameterCheckSection = ({ index, enable, onValUpdate, ...props }) => (
  <div className="blue lp-customcb flex" {...props}>
    <input
      type="checkbox"
      id={`lp${index}`}
      name="enable"
      checked={enable}
      onChange={(event) => onValUpdate(index, event)}
    />
    <label className="innerlp" htmlFor={`lp${index}`} />
  </div>
);

const LoadsParametersRows = ({
  rows,
  tableRowRemove,
  onValUpdate,
  handleInputFocusIn,
  handleInputFocusOut,
  indexSelected,
  showToolTip,
  ...props
}) =>
  rows.map((rowsData, index) => {
    const { title, payload, dx, dy, dz } = rowsData;
    const enable = index === indexSelected;
    return (
      <div
        key={index}
        className="LoadsParametersRows lp-flex-table lp-row-padding lp-table-border-right lp-table-border-left"
        role="rowgroup"
        id={`lpr-${index}`}
        {...props}
      >
        <div className="lp-flex-row-small first" role="cell">
          <LoadParameterCheckSection index={index} enable={enable} onValUpdate={onValUpdate} />
        </div>
        <div className="lp-flex-row-large" role="cell">
          <InputPlaceHolder
            data-testid="input-place-holder-title"
            value={title}
            updateChanges={onValUpdate}
            index={index}
            name="title"
            selected={index === indexSelected}
            onfocusin={handleInputFocusIn}
            onfocusout={handleInputFocusOut}
            error={title === ""}
          />
        </div>
        <div className="lp-flex-row" role="cell">
          <InputPlaceHolder
            data-testid="input-place-holder-payload"
            value={payload}
            updateChanges={onValUpdate}
            index={index}
            unit="Kg"
            name="payload"
            selected={index === indexSelected}
            isNumber
            onfocusin={handleInputFocusIn}
            onfocusout={handleInputFocusOut}
            tooltip={PAYLOAD_TOOLTIP}
            error={payload === "" || payload <= 0 || !Number.isInteger(Number(payload))}
          />
        </div>
        <div className="lp-flex-row" role="cell">
          <InputPlaceHolder
            data-testid="input-place-holder-dx"
            value={dx}
            updateChanges={onValUpdate}
            index={index}
            unit="mm"
            name="dx"
            selected={index === indexSelected}
            isNumber
            onfocusin={handleInputFocusIn}
            onfocusout={handleInputFocusOut}
            tooltip={DISTANCE_TOOLTIP}
            error={dx === "" || !Number.isInteger(Number(dx))}
          />
        </div>
        <div className="lp-flex-row" role="cell">
          <InputPlaceHolder
            data-testid="input-place-holder-dy"
            value={dy}
            updateChanges={onValUpdate}
            index={index}
            unit="mm"
            name="dy"
            selected={index === indexSelected}
            isNumber
            onfocusin={handleInputFocusIn}
            onfocusout={handleInputFocusOut}
            tooltip={DISTANCE_TOOLTIP}
            error={dy === "" || !Number.isInteger(Number(dy))}
          />
        </div>
        <div className="lp-flex-row" role="cell">
          <InputPlaceHolder
            data-testid="input-place-holder-dz"
            value={dz}
            updateChanges={onValUpdate}
            index={index}
            unit="mm"
            name="dz"
            selected={index === indexSelected}
            isNumber
            onfocusin={handleInputFocusIn}
            onfocusout={handleInputFocusOut}
            tooltip={DISTANCE_TOOLTIP}
            error={dz === "" || !Number.isInteger(Number(dz))}
          />
        </div>
        <div className="lp-flex-row-small" role="cell">
          <DeleteCross
            tableRowRemove={tableRowRemove}
            index={index}
            showToolTip={showToolTip}
            disable={showToolTip}
            toolTipMessage={t("cartesian.ui.mechanics.delete_tooltip")}
            data-testid="delete-cross"
          />
        </div>
      </div>
    );
  });
LoadsParametersRows.propTypes = {
  id: PropTypes.string
};

LoadsParametersRows.defaultProps = {
  id: null
};
export default LoadsParametersRows;
